import { Injectable, signal, Signal } from '@angular/core';
import { CompanyModel } from '@one/models/company.model';

/** Só o que o bloco de contato precisa. Nada de CPF/CNPJ, e-mail ou chave PIX: isso vai para o HTML. */
export interface IBootFallbackCompany {
  name: string;
  logoUrl: string | null;
  phone: string;
  isPhoneWhatsapp: boolean;
}

/**
 * Nível B do plano 3 (Fase 4b, Anexo J.2.8): empresa da URL para o bloco de contato que o SSR desenha e que só
 * aparece se o app não subir (iPhone 6 / iOS 12–14.4). Preenchido no servidor pelo companyPreviewResolver.
 */
@Injectable({ providedIn: 'root' })
export class BootFallbackService {
  private readonly current = signal<IBootFallbackCompany | null>(null);
  public readonly company: Signal<IBootFallbackCompany | null> = this.current.asReadonly();

  public setCompany(company: CompanyModel): void {
    this.current.set({
      name: company.name,
      logoUrl: company.logo?.url || null,
      phone: company.phone || '',
      isPhoneWhatsapp: !!company.isPhoneWhatsapp
    });
  }
}
